footer-btn clearfix<template>
	<div v-show="bodyIsShow">
		<!--<input type="hidden" id="groupbyNum" value="1843">
		<input type="hidden" id="addressId" value="0">
		<input type="hidden" id="abTestParamUrl" value="car=0&address=0&">
		<input type="hidden" id="abTestFlag" value="1">-->
		<div class="bodywrap">
		    
		    <!--新增协议 end-->
		    <header>
	            <div class="head" id="scrollsize">
	                <ul  style="height:72px">
	                    <li>{{headerTittle}}</li>
	                </ul>
	            </div>
		    </header>
		    <section>
		        <div class="banner clearfix">
		           <img :src="commmonWebConfig.picHost+'/zhuanti/autoshow/'+headerImgs"/>
		        </div>
		    </section>
		    <section>
		        <div class="brandwrap clearfix">
		            <div class="paraphrase distancetobtn clearfix">
		                <div class="paraphrase-tit">车展凭票入场，&nbsp;票价20元/张</div>
		                <div class="paraphrase-small">
		                    <b class="redstar">*</b>
		                    现在报名可免费领票
		                </div>
		            </div>
		            <form class="formwrap clearfix" id="formwrap">
		            	<div v-if="car == 1" class="sinform">
                            <em class="icon-arror-l"></em>
                                
                            <div @click="getData($event)" class="sinform-text" id="insertCar">请选择意向品牌或车型</div>
                            <div class="icon-arror-r"></div>
                        </div>
		                <div class="sinform">
		                    <em class="signUpfrom-icon signUpfrom-icon01"></em>
		                    <input type="text" class="sinform-text" name="usernane" placeholder="请输入姓名" maxlength="10" id="usernane">
		                </div>
		                <div class="sinform">
		                    <em class="signUpfrom-icon signUpfrom-icon02"></em>
		                    <input type="tel" autocomplete="off" class="sinform-text" name="Phone" placeholder="请输入手机号码" maxlength="11" id="Phone">
		                </div>
		                <div class="signUpform-com code-warp">
		                    <em class="signUpfrom-icon signUpfrom-icon03"></em>
		                    <input id="code" name="code" placeholder="请输入验证码" class="signUpfrom-txt code" type="tel" maxlength="4" />
		                    <button type="button" id="code-btn" class="code-btn" @click="codeBtn($event,'#'+$event.target.id)">获取验证码</button>
		                </div>
		                <div class="sub-wrap">
                            <div :class="['singsubmit','tobtn',{'noclick':isclick}]" @click="submitTop('#insertCar',1)" data-track="carfestivalDetailToutiao-1-signUp" id="index-submit" ut-data-click ut-data-convertid="42715" ut-data-eventtype="FormSubmit">
                                <span class="line">￥20<em></em></span>立即免费领票
                            </div>
		                </div>
		                <div class="addxyroom">*请放心填写,报名即视为同意<a href="javascript:void(0);" class="addxydetail" @click="addxydetail()">《个人信息保护声明》</a> </div>
		                <!--<div class="freetickets">
		                    <div class="ticketicon"></div>
		                    <div class="ticketmenu" id="scrollPerson">
		                        <ul id="scrollPersonAll" v-for="(item,index) in scrollPersonLists">
	                                <li class="menuitem">
	                                    <span class="toright">{{item.username}}</span>
	                                    <span class="toright">{{item.userphone}}</span>
	                                    <span>已免费领票</span>
	                                </li>
		                        </ul>
		                    </div>
		                </div>-->
		                <div class="freetickets" >
		                    <div class="ticketicon"></div>
		                    <div  class="ticketmenu" id="scrollPerson"  style="height: 20px;">
		                        <div   style="height: 10px;">
	                                <ul style="height: 150px;">
	                                	<li v-for="(item,index) in scrollPersonLists">
		                                    <span class="toright">{{item.username}}</span>
		                                    <span class="toright">{{item.userphone}}</span>
		                                    <span>已免费领票</span>
	                                    </li>
	                                </ul>
	                            </div>
		                    </div>
		                </div>
		            </form>
		        </div>
		    </section>
		    <!--广告位-->
		        <section class="brand-table-wrap">
		            <div class="exhibitionbrand">
		                <span class="line"></span> 参展品牌
		                <span class="line"></span>
		            </div>
		            <div class=" bigbrandwrap" id="bigbrandwrap">
		                <div class="brand-table  swiper-container" style="height:260px;">
		                	<!--<mt-swipe :auto="4000">
							  <mt-swipe-item v-for="(item,index) in bannerList"><img class="swiper-img" :src="commmonWebConfig.picHost+'/'+item.imgUrl"></mt-swipe-item>
							</mt-swipe>-->
		                    <mt-swipe :auto="0">
		                    	<mt-swipe-item v-for="n in num">
			                        <ul  class="swiper-slide" >
			                            <em class="brand-img"></em>
			                            <!-- <li v-if="index>=((n-1)*12) && index<=(n*12-1)" class="trackEvent" data-track="carfestivalDetailToutiao-3-brandLink" v-for="(item,index) in exhibitionBrandLists" @click="bigbrandwrapFn($event,item.brandId,'//pic.tuanche.com'+item.brandLogo,item.id,item.brandName)"> -->
			                            <li v-if="index>=((n-1)*12) && index<=(n*12-1)" class="trackEvent" data-track="carfestivalDetailToutiao-3-brandLink" v-for="(item,index) in exhibitionBrandLists" @click="bigbrandwrapFn($event,item.brandId,'//pic.tuanche.com'+item.brandLogo,0,item.brandName)">
			                                <a href="##">
			                                    <!-- <input type="hidden" class="js-bshow-id" :value="item.id" /> -->
												<input type="hidden" class="js-bshow-id" value="0" />
			                                    <input type="hidden" class="js-bshow-brandid" :value="item.brandId" />
			                                    <p>
			                                        <img class="hot-brand-img" :src="commmonWebConfig.picHost+item.brandLogo" />
			                                    </p>
			                                    <p class="hot-brand-tit">{{item.brandName}}</p>
			                                </a>
			                            </li>
			                        </ul>
		                        </mt-swipe-item>
		                    </mt-swipe>
		                    <div class="swiper-pagination"></div>
		                    <!--<div class="swiper-button-next"></div>-->
		                    <!--<div class="swiper-button-prev"></div>-->
		                </div>
		            </div>
					<p class="exhibitionbrand-tip">*最终参展品牌以实际到场为准</p>
		        </section>
		        <section>
		            <div class="giftwrap" >
		                <div class="exhibitionbrand">
		                    <span class="line"></span> 精美礼品
		                    <span class="line"></span>
		                </div>
		                <div class="mygift">
		                    <div class="present-wrap clearfix">
		                        <div class="present"></div>
		                        <div class="present-size">
		                        	<div >
		                                <div class="present-tit">
		                                    <em class="pre-l"></em>
		                                    <span class="pre-txt">{{labelDesc1}}</span>
		                                    <em class="pre-r"></em>
		                                </div>
	                                    <p v-for="(item,index) in gift1">{{item.text}}</p>
	                                    <!--<p>净水器</p>-->
                                    </div>
		                        </div>
		                    </div>
		                    <div class="present-wrap clearfix">
		                        <div class="present02"></div>
		                        <div class="present-right">
	                                <div class="present-tit">
	                                    <em class="pre-l"></em>
	                                    <em class="pre-l"></em>
	                                    <span class="pre-txt">{{labelDesc2}}</span>
	                                    <em class="pre-r"></em>
	                                </div>
                                    <p v-for="(item,index) in gift2">{{item.text}}</p>
		                        </div>
		                    </div>
		                    <div class="clearfix">
		                        <div class="present03"></div>
		                        <div class="present-size">
	                                <div class="present-tit">
	                                    <em class="pre-l"></em>
	                                    <span class="pre-txt">{{labelDesc3}}</span>
	                                    <em class="pre-three"></em>
	                                    <em class="pre-three"></em>
	                                    <em class="pre-three"></em>
	                                </div>
                                    <p v-for="(item,index) in gift3">{{item.text}}</p>
		                        </div>
		                    </div>
		                </div>
		            </div>
		        </section>
		        <div class="exhibitionbrand-tip">"礼品数量有限，先到先得"</div>
		    <!-- 交通攻略 -->
		        <section class="addresswrap clearfix">
		            <div class="exhibitionbrand">
		                <span class="line"></span> 交通指南
		                <span class="line"></span>
		            </div>
		                <div class="RoadGuide clearfix">
		                    <img :src="commmonWebConfig.static+'/img/carfestival/tt-addicon.png'">
		                    <div class="top-add"><span class="road-title">车展地址</span>
		                    </div>
		                    <div class="right-nav">
		                        <a class="gps" :href="'http://uri.amap.com/marker?position='+longitude+','+latitude+'&amp;name='+addresses+'&amp;src=tuanche&amp;coordinate=gaode&amp;callnative=0'"><em class="navicon"></em><span class="font-red">导航</span></a>
		                    </div>
		                </div>
		                <div class="blacksize">{{addresses}}</div>
		                <div class="twoadd">
		                    <div class="lines">
		                        <img :src="commmonWebConfig.static+'/img/carfestival/tt-addicon02.png'">
		                        <!--   <img class="scrollLoading" src="http://static.tuanche.com/wap2017/dist/img/carfestival/tt-addicon02.png" data-url="http://static.tuanche.com/wap2017/dist/img/carfestival/tt-addicon02.png"> -->
		                        <p class="road-title">公交:</p>
		                    </div>
		                    <div class="promptadd">
		                        <p class="point">{{bus}}</p>
		                    </div>
		                </div>
		                <div class="metro">
		                    <div class="underground">
		                        <img :src="commmonWebConfig.static+'/img/carfestival/tt-add-icon03.png'">
		                        <!--           <img class="scrollLoading" src="http://static.tuanche.com/wap2017/dist/img/carfestival/tt-add-icon03.png" data-url="http://static.tuanche.com/wap2017/dist/img/carfestival/tt-add-icon03.png"> -->
		                        <p class="road-title">地铁:</p>
		                    </div>
		                    <div class="threeadd">
		                        <p class="point">{{subways}}</p>
		                    </div>
		                </div>
		        </section>
		    <!-- 保障 -->
		    <section>
		        <div class="exhibitionbrand">
		            <span class="line"></span> 车展保障
		            <span class="line"></span>
		        </div>
		        <div class="servicewrap clearfix">
		            <ul>
		                <li class="clearfix">
		                    <div class="serve-border">
		                        <div class="clearfix serve-icon-warp">
											<span class="fl serve-icon">
		                                    <em class="serve-icon-zi"></em>
		                                </span>
		                            <em class="fl serve-icon-arr"></em>
		                        </div>
		                        <div class="serve-txt">
		                            <p class="serve-txt-tit">品牌齐全</p>
		                            <p class="serve-txt-gary">覆盖了自主、合资、</p>
		                            <p class="serve-txt-gary">进口等超过100个汽车品牌</p>
		                        </div>
		                    </div>
		                </li>
		                <li class="clearfix">
		                    <div class="serve-border">
		                        <div class="clearfix serve-icon-warp">
											<span class="fl serve-icon">
		                                    <em class="serve-icon-zi serve-icon-zi2"></em>
		                                </span>
		                            <em class="fl serve-icon-arr"></em>
		                        </div>
		                        <div class="serve-txt">
		                            <p class="serve-txt-tit">车型丰富</p>
		                            <p class="serve-txt-gary">百款车型任您选择</p>
		                            <p class="serve-txt-gary">看车选车比价一站式完成</p>
		                        </div>
		                    </div>
		                </li>
		                <li class="clearfix">
		                    <div class="serve-border">
		                        <div class="clearfix serve-icon-warp">
											<span class="fl serve-icon">
		                                    <em class="serve-icon-zi serve-icon-zi3"></em>
		                                </span>
		                            <em class="fl serve-icon-arr"></em>
		                        </div>
		                        <div class="serve-txt">
		                            <p class="serve-txt-tit">低价优惠</p>
		                            <p class="serve-txt-gary">车款价格层层对比</p>
		                            <p class="serve-txt-gary">车展为您提供有竞争力的市场低价</p>
		                        </div>
		                    </div>
		                </li>
		                <li class="clearfix">
		                    <div class="serve-border">
		                        <div class="clearfix serve-icon-warp">
											<span class="fl serve-icon">
		                                    <em class="serve-icon-zi serve-icon-zi4"></em>
		                                </span>
		                            <em class="fl serve-icon-arr"></em>
		                        </div>
		                        <div class="serve-txt">
		                            <p class="serve-txt-tit">售后保障</p>
		                            <p class="serve-txt-gary">现场车源全国联保</p>
		                            <p class="serve-txt-gary">出现问题车展协助解决</p>
		                        </div>
		                    </div>
		                </li>
		                <li class="clearfix">
		                    <div class="serve-border">
		                        <div class="clearfix serve-icon-warp">
											<span class="fl serve-icon">
		                                    <em class="serve-icon-zi serve-icon-zi5"></em>
		                                </span>
		                            <em class="fl serve-icon-arr"></em>
		                        </div>
		                        <div class="serve-txt">
		                            <p class="serve-txt-tit">服务保证</p>
		                            <p class="serve-txt-gary">专属销售免费服务</p>
		                            <p class="serve-txt-gary">力保您省时省力更省心</p>
		                        </div>
		                    </div>
		                </li>
		                <li class="clearfix">
		                    <div class="serve-border">
		                        <div class="clearfix serve-icon-warp">
											<span class="fl serve-icon">
		                                    <em class="serve-icon-zi serve-icon-zi6"></em>
		                                </span>
		                            <em class="fl serve-icon-arr"></em>
		                        </div>
		                        <div class="serve-txt">
		                            <p class="serve-txt-tit">车源保证</p>
		                            <p class="serve-txt-gary">优质4s店供车</p>
		                            <p class="serve-txt-gary">保证您现场买到优质车源</p>
		                        </div>
		                    </div>
		                </li>
		            </ul>
		        </div>
		    </section>
		    <!-- 底部 -->
		    <agreementComponentQuo></agreementComponentQuo>
		    <!-- 侧拉品牌 -->
		    <div class="sider-mark" id="sider-mark"></div>
		    <div class="sider-wrap" id="sider-wrap">
		        <!--<div id="side-brand" class="side-div side-brand">
		        	<div class="side-header">
		        		<span class="side-back-all"></span>
		        		<span class="title">选择品牌</span>
		        	</div>-->
		        	
		        	
		        	<!--<div id="side-brand" class="side-div side-brand">
				      	<div class="side-header"><span class="side-back-all"></span><span class="title">选择品牌</span></div>
				      	<div v-for="(item,index) in rrcBrandList">
				      	<dl class="side-list">
				      		<dt class="side-list-dt">{{index}}</dt>
				      		<dd v-for="(itemChildren,index) in item" class="side-list-dd" :data-rel="itemChildren.id">{{itemChildren.name}}</dd>
				      	</dl>
				      	</div>
				      	<div class="ziMuBody">
				            <ul class="ziMuUl">
					        	<li v-for="(item,index) in rrcBrandList"  class="zimu">{{index}}</li>
					        </ul>
				        </div>        
				    </div>      -->
		        	
		        	
		        	
		        	
		        	<!--<dl class="side-list">
		        		<dt class="side-list-dt">A</dt>
		        		<dd class="side-list-dd" data-rel="64">
		        			<img src="http:////pic.tuanche.com/car/20150420/14295252049006627_s.jpg">
		        			阿尔法·罗密欧
		        		</dd>
		        		<dd class="side-list-dd" data-rel="25">
		        				<img src="http:////pic.tuanche.com/car/20170615/14975150455597365_s.jpg">
		        				奥迪
		        		</dd>
		        	</dl>
		        	<div class="ziMuBody" style="height: 440px;">
		        		<ul class="ziMuUl">
		        			<li class="zimu">
		        				A
		        			</li>
		        			<li class="zimu">
		        				B
		        			</li>
		        			<li class="zimu">
		        				C
		        			</li><li class="zimu">D</li><li class="zimu">F</li><li class="zimu">G</li><li class="zimu">H</li><li class="zimu">J</li><li class="zimu">K</li><li class="zimu">L</li><li class="zimu">M</li><li class="zimu">N</li><li class="zimu">O</li><li class="zimu">Q</li><li class="zimu">R</li><li class="zimu">S</li><li class="zimu">T</li><li class="zimu">W</li><li class="zimu">X</li><li class="zimu">Y</li><li class="zimu">Z</li>
		        		</ul>
		        	</div>
		        </div>-->
		        
		        
		        
		        
		        <!--<div id="side-carstyle" class="side-div side-carstyle">
		        	<div class="side-header"><span class="side-back"></span><span class="title">选择车型</span></div>
		        	<dl class="side-list"><dt class="side-list-dt">阿尔法·罗密欧</dt><dd class="clearfix side-list-dd" data-rel="84@#32325"><div class="fl carimg"><img src="http://pic.tuanche.com/car/20170322/14901524868931379_o.jpg"></div><div class="fl carinfo"><p class="carname">Giulia</p><p class="gray carprice">31.98-94.98万</p></div></dd><dd class="clearfix side-list-dd" data-rel="84@#32400"><div class="fl carimg"><img src="http://pic.tuanche.com/car/20170603/14964742687718321_o.jpg"></div><div class="fl carinfo"><p class="carname">Stelvio</p><p class="gray carprice">39.98-96.98万</p></div></dd></dl>
		        </div>-->
		    </div>
		    <div class="sider-mark" id="sider-mark"></div>
		    <div class="sider-wrap" id="sider-wrap">
		        <div id="side-brand" class="side-div side-brand">
		        </div>
		        <div id="side-carstyle" class="side-div side-carstyle"></div>
		    </div>
		    <!-- 弹窗蒙层 -->
		    <div class="pop-mark" @click="popMark()"></div>
		    <div class="showmarsk">
		        <form class="formwrap" id="maskform">
		        	<div class="markdel"  @click="markdels()"></div>
		        	<div v-if="car == 1" class="sinform">
                        <em class="icon-arror-l"></em>
                        <div class="sinform-text" id="maskbrand"  @click="getData($event)">请选择意向品牌或车型</div>
                        <div class="icon-arror-r"></div>
                    </div>
		            <div class="sinform">
		                <em class="signUpfrom-icon signUpfrom-icon01"></em>
		                <input type="text" class="sinform-text" name="showmarskname" placeholder="请输入姓名" maxlength="10" id="mask-usernane">
		            </div>
		            <div class="sinform">
		                <em class="signUpfrom-icon signUpfrom-icon02"></em>
		                <input type="tel" autocomplete="off" class="sinform-text" name="showmarskphone" placeholder="请输入手机号码" maxlength="11" id="msak-phone">
		            </div>
		            <div class="inputwrap code-warp">
		                <input id="pop-code" type="tel" placeholder="请输入验证码" class="code">
		                <button type="button" class='code-btn' id="pop-code-btn"  @click="codeBtn($event,'#'+$event.target.id)">获取验证码</button>
		            </div>
		            <div class="mask-wrap">
                        <div  :class="['singsubmit',{'noclick':isMaskclick}]" @click="submitTop('#maskbrand',2)" id="mask-submit" ut-data-click ut-data-convertid="42715" ut-data-eventtype="FormSubmit">
                            <span class="line">￥20<em></em></span>立即免费领票
                        </div>
		                <div class="agreement">
		                    *请放心填写,报名即视为同意
		                    <span class="protocol" id="mask-protocol"  @click="addxydetail()">《个人信息保护声明》</span>
		                </div>
		            </div>
		        </form>
		    </div>
		    
		<footer>
            <div class="footerwrap clearfix marT">
                <div class="footer-btn clearfix">
                    <p class="gray" style="margin-bottom: 8px;margin-top: 32px;">有车约（北京）信息技术有限公司</p>
                    <p class="gray">京ICP备18001177号-1</p>
                </div>
            </div>
        </footer>
		<div class="topBack"></div>
		</div>
		
		<div  class="tow-mask-brand">
		    <p>
		        <img :src="popInfo.brandImg">
		        <!--       <img class="scrollLoading" src="//static.tuanche.com/wap2017/dist/img/common/blank.gif" data-url="http://pic.tuanche.com/car/20170221/14876732832273050_s.jpg"> -->
		    </p>
		</div>
		<div class="markdel" @click="markdels()"></div>
		<div class="towshowmarsk clearfix">
		    <div class="tow-tit">
		        <span class="fastcar"></span>
		    </div>
		    <div class="marks-form">
		        <em class="marks-form-icon marks-form-icon01"></em>
		        <input type="text" autocomplete="off" class="sinform-text" name="usernane" placeholder="请输入姓名" maxlength="10" id="maskName">
		    </div>
		    <div class="marks-form">
		        <em class="marks-form-icon marks-form-icon02"></em>
		        <input type="tel" class="sinform-text" name="usernane" placeholder="请输入手机号码" maxlength="11" id="maskPhone">
		    </div>
		    <div class="inputwrap code-warp">
		        <input id="pop-brand-code" type="tel" placeholder="请输入验证码" class="code">
		        <button type="button" class='code-btn' id="pop-brand-code-btn" @click="codeBtn($event,'#'+$event.target.id)">获取验证码</button>
		    </div>
		    <div class="sin-fast">
                <div :class="['sin-msak-submit',{'noclick':isSinMaskclick}]" ut-data-click ut-data-convertid="42715" ut-data-eventtype="FormSubmit" @click="SubmitSty()">
                    <span class="line">￥20<em></em></span>立即免费领票
                </div>
		        <div class="agreement">
		            温馨提示：报名即视为同意
		          <span class="protocol" id="sin-maskprotocol"  @click="addxydetail()">《个人信息保护声明》</span>
		        </div>	
		        <!-- <div class="sin-msak-submit">快速领票</div> -->
		    </div>
		    <p class="btn-size">报名到场，即享三重豪华礼包！</p>
		    <div class="btn-img">
		        <div class="img-item toright">
		            <p> <img :src="commmonWebConfig.static+'/img/carfestival/tt-img.png'"></p>
		            <p class="txt">签到</p>
		        </div>
		        <div class="imgarror"></div>
		        <div class="img-item toright">
		            <p> <img :src="commmonWebConfig.static+'/img/carfestival/tt-img02.png'"></p>
		            <p class="txt">订车 </p>
		        </div>
		        <div class="imgarror-r"></div>
		        <div class="img-item">
		            <p> <img :src="commmonWebConfig.static+'/img/carfestival/tt-img03.png'"></p>
		            <p class="txt"> 抽奖</p>
		        </div>
		
		    </div>
		
		    
		        <input type="hidden" id="ocpcId" name="ocpcId" value="1607397501329432"/>
		        <input type="hidden" id="promotionCanal" name="promotionCanal" value="jr15METC"/>
		    
		</div>
		<div class="tikect-fixed trackEvent" data-track="carfestivalDetailToutiao-2-signUpFixed" @click="trackEvent()">
		    
		            <span class="line">￥20<em></em></span>立即免费领票
		        
		</div>
		<!--广告弹窗-->
		<div id="adPop-mark" class="adPop-mark"></div>
		<div id="adPop" class="signUpfrom adPop">
		    <div class="adPop-tit">请先选择您中意的车型</div>
		    <form id="signUpfromPop">
		        <div class="signUpform-com">
		            <em class="signUpfrom-icon signUpfrom-icon01"></em>
		            <input id="userNamePop" name="userName" placeholder="请输入姓名" class="signUpfrom-txt userName" type="text" maxlength="10" />
		        </div>
		            <div class="signUpform-com">
		
		            <em class="signUpfrom-icon signUpfrom-icon02"></em>
		            <input id="telphonePop" name="telphone" placeholder="请输入手机号码" class="signUpfrom-txt telphone" type="tel" maxlength="11" />
		        </div>
		        <div class="signUpform-com">
		            <em class="signUpfrom-icon signUpfrom-icon03"></em>
		            <div id="insertCarPop" class="signUpfrom-txt">请输入意向品牌和意向车型</div>
		            <em class="icon-arror-r"></em>
		        </div>
		        <div id="adPopBtn" class="adPopBtn">
		            下一步
		        </div>
		    </form>
		</div>
		
	</div>
</template>
<style scoped lang="less">
	.noclick{
		pointer-events: none;
	}
</style>
<script>
	String.prototype.GetValue = function (para) {
			var reg = new RegExp("(^|&)" + para + "=([^&]*)(&|$)");
			var r = this.substr(this.indexOf("\?") + 1).match(reg);
			if (r != null && r[2].indexOf("#") > 0) {
				r[2] = r[2].substring(0, r[2].indexOf("#"));
			}
			if (r != null) return decodeURI(r[2]); return null;
		};
	
	import { Toast } from 'mint-ui';
	export default {
	name: 'applypage',
	data() {
		return {
			bodyIsShow:false,
			num:0,
			address:'',
			car:'',
			bannerShow: {
				headerImg: "http://pic.tuanche.com/zhuanti/autoshow/15318750056838157.jpg"
			},
			scrollPersonLists:[],
			presentTitles:'',
			bus:'',
			subways:'',
			addresses:'',
			exhibitionBrandLists:[],
			headerImgs:'',
			headerIntroLists:[],
			headerTittle:'',
			presentLists:[],
			tc_bz:[],
			rrcBrandList:[],
			cityId:'10',
			groupbyNum:'',
			applyId:'',
			cityPy:'bj',
			tAutoshowPeriodsOcpc:null,
			ocpcId:"",
			gift1:[],
			gift2:[],
			gift3:[],
			labelDesc1:'',
			labelDesc2:'',
			labelDesc3:'',
			curBrandURL:'',
			longitude:'',
			latitude:'',
			//弹出窗口信息
			popInfo:{
				brandId:"",
				brandImg:"",
				carStyleId:""
			},
			isBrandCarStyleId: false,	//判断首次加载未选择品牌和车型
			isclick:false,
			isMaskclick:false,
			isSinMaskclick:false,
			periodsType:8
			
		}
	},
//	beforeCreate: function() {
//	},
	mounted: function() {
		var self = this;
		getCommonJsIns.initCSSNEW();
		getCommonJsIns.initSingleCSSNEW({
        cssURL:"/css/mapply/quotationpage/quotationpage.css?v=123"
      });
		//确保重要依赖的js加载完成
		getCommonJsIns.initJSNEW(this.webReady);
		//替换行情的icon
		var linkList = document.getElementsByTagName("link");
		for(var i=0; i<linkList.length;i++){
			if(linkList[i].type == "image/x-icon"){
				linkList[i].href = pathWebCommonUtils + "/img/common/V.ico"
			}
		};
	},
	methods: {
		webReady: function() {
			var self = this;
			if(this.$route.query.cityPy){
				self.cityPy=this.$route.query.cityPy
			}
			this.scollTop();
			getCommonJsIns.loadJs(getCommonJsIns.scriptUrl["kxbdmarquee"],function(){
				self.kxbdMarq("#scrollPerson");
				self.kxbdMarq("#scrollsize");
			});
			if(self.$route.query.activityType){
				self.periodsType=self.$route.query.activityType;
			}
			this.ajaxSubmit.ajax({
				url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.abTest+"?cityPy="+self.cityPy+'&autoShowContentType=6&periodsType='+self.periodsType,
				type:"get",
				dataType:"json",
				success:function(data){
					var result = data.response.result;
					if(data.responseHeader.status == 200){
//						self.tc_bz = result;
						self.address=result.address;
						self.car=result.car;
					}else{
					}
				},
				error:function(){}
			});
			this.ajaxSubmit.ajax({
				url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.tcj+"/"+self.cityPy+"?autoShowContentType=6&periodsType="+self.periodsType,
//				url:"//172.16.3.45/adConfig/tcj/bj?autoShowContentType=8",
				type:"get",
				dataType:"json",
				success:function(data){
					var result = data.response.result;
					if(data.responseHeader.status == 200){
						self.bodyIsShow = true;
						self.scrollPersonLists=result.applyListMap;
						
						self.headerIntroLists=result.concentMap.autoShowInfo.headerIntroList;
						for(var key in self.headerIntroLists){
							self.headerTittle = self.headerIntroLists[key].text
						}
						self.bus=result.concentMap.bus;
						self.subways=result.concentMap.subway;
						self.addresses=result.periodsInfo.address;
						console.log(self.addresses);
						self.exhibitionBrandLists=result.periodsInfo.exhibitionBrandList;
						
						
						self.longitude = result.periodsInfo.longitude;
						self.latitude = result.periodsInfo.latitude;
						
						self.groupbyNum=result.periodsInfo.id;
						self.cityId=result.periodsInfo.cityId;
						self.num = Math.ceil(self.exhibitionBrandLists.length/12);
						self.headerImgs =result.concentMap.autoShowInfo.headerImg;
						self.presentLists =result.concentMap.autoShowInfo.presentList;
						document.title = result.periodsInfo.title;
						self.periodsType = result.periodsInfo.activityType;
						self.tAutoshowPeriodsOcpc = result.concentMap.autoShowInfo.tAutoshowPeriodsOcpc;
						if(result.concentMap.autoShowInfo.tAutoshowPeriodsOcpc!=null){
							self.tAutoshowPeriodsOcpc.ocpcId = result.concentMap.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId;
							self.tAutoshowPeriodsOcpc.promotionCanal = result.concentMap.autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal;
							self.tojiIcpc(self.tAutoshowPeriodsOcpc.ocpcId);
						};
						
						self.gift1 =result.concentMap.presentMap[0];
						for(var i in self.gift1){
							self.labelDesc1=self.gift1[i].labelDesc;
						}
						self.gift2 =result.concentMap.presentMap[1];
						for(var i in self.gift2){
							self.labelDesc2=self.gift2[i].labelDesc;
						}
						self.gift3 =result.concentMap.presentMap[2];
						for(var i in self.gift3){
							self.labelDesc3=self.gift3[i].labelDesc;
						}
					}else{
						if(data.response.result.cityId){
							window.cityId = data.response.result.cityId;
						}else{
							window.cityId = self.cityId;
						}
            			window.location.href=SIGNTUREURL.signURL+'/bmtcj?cityId='+window.cityId;
					}
				},
				error:function(data){
					if(data.response.result.cityId){
						window.cityId = data.response.result.cityId;
					}else{
						window.cityId = self.cityId;
					}
					window.location.href=SIGNTUREURL.signURL+'/bmtcj?cityId='+window.cityId;
				}
			});
			self.resetForm();
			
		},
		tojiIcpc:function(ocpcId){
			var ocpcId = ocpcId;
			
			(function (root) {
			    root._tt_config = true;
			    var ta = document.createElement('script'); ta.type = 'text/javascript'; ta.async = true;
			    ta.src = document.location.protocol + '//' + 's3.pstatp.com/bytecom/resource/track_log/src/toutiao-track-log.js';
			    ta.onerror = function () {
			        var request = new XMLHttpRequest();
			        var web_url = window.encodeURIComponent(window.location.href);
			        var js_url = ta.src;
			        var url = '//ad.toutiao.com/link_monitor/cdn_failed?web_url=' + web_url + '&js_url=' + js_url + '&convert_id=' + ocpcId;
			        request.open('GET', url, true);
			        request.send(null);
			    }
			    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ta, s);
			})(window);
		},
		resetForm:function(){
			var self =this;
			$(".code-warp").hide();
//			if(self.car=='0'){
//				$("#formwrap").children(".sinform").eq(0).css("display","none");
//				$("#maskform").children(".sinform").eq(0).css("display","none");
//			}else{
//				$("#formwrap").children(".sinform").eq(0).css("display","block");
//				$("#maskform").children(".sinform").eq(0).css("display","block");
//			}
		},
		scollTop:function(){
			$(window).scroll(function() {
				if($(window).scrollTop() > $("#index-submit").offset().top) {
					$(".tikect-fixed").show();
					$(".topBack").show();
					
				} else {
					$(".tikect-fixed").hide();
					$(".topBack").hide();
				}
			});
		
			
		},
		kxbdMarq: function(obj){
			$(obj).kxbdMarquee({
				direction: "up",
				isEqual: false,
				scrollDelay: 40
			});
		},
		addxydetail:function(){
			$(".xymarsk").show();
			$(".addxypop-mark").show();
			$('html').css({
				"overflow-y": "hidden"
			});
			$('body', 'html').css({
				"position": "fixed",
				"left": "50%",
				"margin-left": "-5rem",
				"top": 0
			});
		},
		getStyleCar:function(){
			var self =this;
			$("#side-brand").delegate(".side-list-dd", "click", function() {

		        var brandId = $(this).data("rel");
		        var brandName = $(this).text();
		        $(this).closest(".side-div").css("display", "none");
		        $("#side-carstyle").css("display", "block").html("<div class='seo-loading'>正在加载，请稍后</div>");
		        $("#side-carstyle").css("display", "block");
		        self.ajaxSubmit.ajax({
					url:self.commmonWebConfig.tuancheapi+self.ajaxSubmit.allUrl.baseDataTcStyle+"?brandId="+brandId,
					//url:"http://oo.tuanche.com:8083/data/data.js"
					type:"get",
					dataType:"json",
					success:function(data){
						$("#side-brand").data("dada", brandId);
		                $("#side-brand").data("name", brandName);
		                var header = '<div class="side-header">' +
		                    '<span class="side-back"></span>' +
		                    '<span class="title">选择车型</span>' +
		                    '</div>';
		                var contentStr = "";
		                for(var i in data.response.result){
		                //if(data[i].length>0){                       
			                contentStr += '<dl class="side-list">'
			                for (var j in data.response.result[i].styleList) {
			                    contentStr += '<dd class="side-list-dd" data-rel="' + data.response.result[i].styleList[j].id + '">' + data.response.result[i].styleList[j].styleName + '</dd>';
			                }
			                contentStr += '</dl>';
		                //}
		                };
		                $("#side-carstyle").html(header + contentStr);
		                self.getCarModels();
					},
					error:function(){
						$(this).closest(".side-div").css("display", "none");
		                $("#side-brand").hide();
		                alert("系统忙，请稍后");
					}
				});
		    })
		},

		trackEvent:function(){
			$('.pop-mark').show();
			$(".showmarsk").show();
			$(".showmarsk .markdel").show();
		},
		popMark:function(){
			$('.pop-mark').hide();
			$('.sider-wrap').hide();
			$(".showmarsk").hide();
			$(".towshowmarsk").hide();
			$(".markdel").hide();
			$(".tow-mask-brand p").hide();
			$('html').css({
				"overflow": "auto"
			});
			//关闭弹窗还回到点击的位置
			$('body', 'html').css({
				"position": "static",
				"width": "10rem",
				"margin": "0 auto"
			});
		},
		bigbrandwrapFn:function(e,brandId,brandImg,carStyleId,brandName){
			var obj = e.target;
			this.popInfo.brandId = brandId;
			this.popInfo.carStyleId = carStyleId;
			$(".tow-mask-brand").find("img").attr("src", brandImg);
			$(".towshowmarsk").find(".tow-tit .fastcar").text("快速领票-" + brandName);
			$('.pop-mark').show();
			$(".towshowmarsk").show();
			$(".markdel").show();
			$(".tow-mask-brand p").show();
			$('html').css({
				"overflow-y": "hidden"
			});
			$('body', 'html').css({
				"position": "fixed",
				"left": "50%",
				"margin-left": "-5rem",
				"top": 0
	
			}); //弹窗打开页面固定
		},
		markdels:function(){
			$('.pop-mark').hide();
			$(".towshowmarsk").hide();
			$(".markdel").hide();
			$(".tow-mask-brand p").hide();
			$('html').css({
				"overflow": "auto"
			});
			//关闭弹窗还回到点击的位置
			$('body', 'html').css({
				"position": "static",
				"width": "10rem",
				"margin": "0 auto"
			});
			$(".showmarsk").hide();
			$('.pop-mark').hide();
			$(window).scrollTop(brandTop);
		},
		checkData:function(name,phone,code){
			if($(name).val()=='' || !webCommonUtil.commonFun.isName($(name).val())){
				Toast({
                  message: "请填写真实姓名",
                  position: 'middle',
                  duration: 2000
                });
                return false;
			}else if(!webCommonUtil.commonFun.isPhone($(phone).val())){
				Toast({
                  message: "请填写11位手机号码",
                  position: 'middle',
                  duration: 2000
                });
                return false;
			}
			else {
				return true;
			}
		},
		getData:function(event){
			var self = this;
          webCommonUtil.getBrandCarStyle.init({
              domObj:event.target,
              callback:function(){
				self.isBrandCarStyleId = true;
              },
              ajaxBrandParams:{
                url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.tcBrand,
                type:"post",
                dataType:"json",
                async:false,
                data:{
                  cityId:self.cityId
                }
              },
              ajaxCarStyleParams:{
                url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.baseDataTcStyle,
                type:"post",
                dataType:"json",
                async:false,
                data:{
                  cityId:self.cityId
                }
              }
            });
     },
		subfrom:function(curdata){
				var self = this;
				curdata.car = self.car;
				curdata.address = self.address;
				self.ajaxSubmit.ajax({
					type: "post",
					url:self.commmonWebConfig.tuancheapi+self.ajaxSubmit.allUrl.applyForTcjAsyn,
					dataType: 'json',
					data: curdata,
					async: false,
					success: function(data) {
						if(data.responseHeader.status == 200) {
							self.isclick=false;
							self.isMaskclick=false;
							self.isSinMaskclick=false;
							var result = data.response.result;
							self.applyId=result.result.applyId;
							if(result.code == 10000){
								var c = window.location.href.GetValue("c");
								if(self.tAutoshowPeriodsOcpc != null && c == self.tAutoshowPeriodsOcpc.promotionCanal) {
									var id = self.tAutoshowPeriodsOcpc.ocpcId;
									if(id != "") {
										_taq.push({
											convert_id: id,
											event_type: "form"
										});
									}
								}
								Toast({
				                  message: result.msg,
				                  position: 'middle',
				                  duration: 2000
				                });
								window.location.href ="/mapply/toutiaoQuotation/perfect?address="+self.address+"&applyId=" + self.applyId + "&t=" + Date.parse(new Date()) + "&buyway=0&instalments=0&otherbrand=0&periodsId=" +self.groupbyNum +"&cityId="+self.cityId +"&car="+self.car+"&sk="+data.response.result.result.sk+'&autoShowContentType=6&periodsType=8';
							

							} 
						}
					},
					error: function() {
						self.isclick=false;
						self.isMaskclick=false;
						self.isSinMaskclick=false;
						Toast({
							msg: "系统忙，请稍后",
							bottom: "50%"
						});
					}

				});
		},
		SubmitSty:function(){
			var self = this;
			var buyType = "";
			var splitMoney = "";
			var otherbrand = "";
			if(self.checkData("#maskName","#maskPhone","#pop-brand-code")){
				var curWindow = window.location.href;
				if(curWindow.indexOf("?")==-1){
					curWindow = curWindow+'?car='+self.car+'&address='+self.address
				}else{
					curWindow = curWindow+'&car='+self.car+'&address='+self.address
				}
				var data = {
					"sourceUrl": curWindow,
					"cityId": self.cityId,
//					"brandId":$(".js-bshow-brandid").val(),
//					"carStyleId":$(".js-bshow-id").val(),
					"name": $("#maskName").val(),
					"phone": $("#maskPhone").val(),
					"groupbyNum": self.groupbyNum,
					"groupbyType": self.periodsType,
					"checkIp": false,
					"noCheckBrandStyle":0,
					"sourceId":'-1',
					"bmtype":'market_toutiao_apply'
				};
				data["brandId"]=this.popInfo.brandId,
			    data["carStyleId"]= this.popInfo.carStyleId,
				data['noCheckBrandStyle'] = 0;
				self.isSinMaskclick=true;
				self.subfrom(data);
			}
		},
		submitTop:function(objId,type){
//			$("#js-brand").attr("disabled", "disabled");
//			$("#signUpButton").removeAttr("disabled");
			var self = this;
			if(self.car=='0'){
				objId='';
			}
			var brandType =$(objId).data("brandId");
			var carType =$(objId).data("carstyleId");
			var buyType = "";
			var splitMoney = "";
			var otherbrand = "";
			var checkStatus;
			var names;
			var phones;
			// console.log($(objId).data("brandId"));
			// console.log($(objId).data("carstyleId"));
			if(self.car!='0'){
				if(!this.isBrandCarStyleId || $(objId).data("brandId") == '' || $(objId).data("carstyleId")==''){
					Toast({
						message: "请选择品牌和车型",
	                  	position: 'middle',
	                  	duration: 2000
	                });
	                return false;
				}
			}
			if(type==1){
				checkStatus = self.checkData("#usernane","#Phone","#code");
				names = "#usernane";
				phones = "#Phone";
			}else{
				checkStatus = self.checkData("#mask-usernane","#msak-phone","#pop-code");
				names = "#mask-usernane";
				phones = "#msak-phone";
			}
			if(checkStatus){
				var curWindow = window.location.href;
				if(curWindow.indexOf("?")==-1){
					curWindow = curWindow+'?car='+self.car+'&address='+self.address
				}else{
					curWindow = curWindow+'&car='+self.car+'&address='+self.address
				};
				var data = {
					"sourceUrl": curWindow,
					"cityId": self.cityId,
					"name": $(names).val(),
					"phone": $(phones).val(),
					"groupbyNum": self.groupbyNum,
					"groupbyType": self.periodsType,
					"buyType": buyType,
					"splitMoney": splitMoney,
					"otherBrand": otherbrand,
					"checkIp": true,
					"noCheckBrandStyle":0,
					"sourceId":'-1',
					"bmtype":'market_toutiao_apply'
				};
				if(self.car=='0') {
					data['noCheckBrandStyle'] = 1; //无值传1

				} else {
					data["brandId"]=$(objId).data("brandId");
				    data["carStyleId"]= $(objId).data("carstyleId");
					data['noCheckBrandStyle'] = 0;
				}
				if(type==1){
					self.isclick=true;
				}else{
					self.isMaskclick=true;
				}
				self.subfrom(data);
			}
			
			
		}
	}
}</script>


// WEBPACK FOOTER //
// src/views/toutiaoQuotation/quotationpage.vue